






import { Vue, Component, Watch } from 'vue-property-decorator'
import $ from 'jquery'
import Delay from 'lodash/delay'
import { Route } from 'vue-router'

interface PointsType {
    x: number
    y: number
    originX: number
    originY: number
}

@Component({})
export default class SvgPolygons extends Vue {
  private isMounted: boolean = false
  private color: string = ''
  private canAnimate: boolean = true
  private refreshTimeout: number = 0
  private refreshDuration: number = 10000
  private resizeTimeout: number = 0
  private resizeDuration: number = 250
  private numPointsX: number = 0
  private numPointsY: number = 0
  private unitWidth: number = 0
  private unitHeight: number = 0
  private points: Array<PointsType> = []

  pageColors: Array<{ pageName: string; color: string }> = []

  setColorBeforeLoad(routeName: string) {
    // const routeName = route.toString()
    const pageColor = this.pageColors.find(
      (item) => item.pageName === routeName
    )
    if (pageColor) {
      this.canAnimate = false
      Delay(() => {
        this.color = pageColor.color
        this.canAnimate = true
        this.onResize()
      }, 2000)
    }
  }

  onResize() {
    $(this.$refs.bg).find('svg').remove()
    window.clearTimeout(this.refreshTimeout)
    window.clearTimeout(this.resizeTimeout)
    this.resizeTimeout = window.setTimeout(() => {
      this.onLoad()
    }, this.resizeDuration)
  }

  @Watch('$route', { deep: true, immediate: true })
  onUrlChange(route: Route) {
    if (route && route?.name) {
      // const tmp: string[] = route.name.split('___')
      // const routeName: string = tmp[0]
      if (this.isMounted) {
        this.setColorBeforeLoad(route.name)
      }
    }
  }

  refresh() {
    this.randomise()
    const polygons = $(this.$refs.bg).find('svg').children()
    for (let i: number = 0; i < polygons.length; i++) {
      const polygon: any = polygons[i]
      const animate: any = polygon.childNodes[0]
      if (animate.getAttribute('to')) {
        animate.setAttribute('from', animate.getAttribute('to'))
      }
      animate.setAttribute(
        'to',
        this.points[polygon.point1].x +
          ',' +
          this.points[polygon.point1].y +
          ' ' +
          this.points[polygon.point2].x +
          ',' +
          this.points[polygon.point2].y +
          ' ' +
          this.points[polygon.point3].x +
          ',' +
          this.points[polygon.point3].y
      )
      if ('beginElement' in animate) {
        animate.beginElement()
      }
    }
    this.refreshTimeout = window.setTimeout(
      () => this.refresh(),
      this.refreshDuration
    )
  }

  randomise() {
    for (let i: number = 0; i < this.points.length; i++) {
      if (
        this.points[i].originX !== 0 &&
        this.points[i].originX !== this.unitWidth * (this.numPointsX - 1)
      ) {
        this.points[i].x =
          this.points[i].originX +
          Math.random() * this.unitWidth -
          this.unitWidth / 2
      }
      if (
        this.points[i].originY !== 0 &&
        this.points[i].originY !== this.unitHeight * (this.numPointsY - 1)
      ) {
        this.points[i].y =
          this.points[i].originY +
          Math.random() * this.unitHeight -
          this.unitHeight / 2
      }
    }
  }

  onLoad() {
    const svgElement = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'svg'
    )
    const x = window.innerWidth || document.documentElement.clientWidth
    const y = window.innerHeight || document.documentElement.clientHeight
    svgElement.setAttribute('width', x.toString())
    svgElement.setAttribute('height', y.toString())
    const bgElement = $(this.$refs.bg)
    bgElement.append(svgElement)
    const unitSize: number = (x + y) / 20
    this.numPointsX = Math.ceil(x / unitSize) + 1
    this.numPointsY = Math.ceil(y / unitSize) + 1
    this.unitWidth = Math.ceil(x / (this.numPointsX - 1))
    this.unitHeight = Math.ceil(y / (this.numPointsY - 1))
    this.points = []
    for (let y: number = 0; y < this.numPointsY; y++) {
      for (let x: number = 0; x < this.numPointsX; x++) {
        this.points.push({
          x: this.unitWidth * x,
          y: this.unitHeight * y,
          originX: this.unitWidth * x,
          originY: this.unitHeight * y,
        })
      }
    }
    this.randomise()
    for (let i = 0; i < this.points.length; i++) {
      if (
        this.points[i].originX !== this.unitWidth * (this.numPointsX - 1) &&
        this.points[i].originY !== this.unitHeight * (this.numPointsY - 1)
      ) {
        const topLeftX: number = this.points[i].x
        const topLeftY: number = this.points[i].y
        const topRightX: number = this.points[i + 1].x
        const topRightY: number = this.points[i + 1].y
        const bottomLeftX: number = this.points[i + this.numPointsX].x
        const bottomLeftY: number = this.points[i + this.numPointsX].y
        const bottomRightX: number = this.points[i + this.numPointsX + 1].x
        const bottomRightY: number = this.points[i + this.numPointsX + 1].y
        const rando: number = Math.floor(Math.random() * 2)
        for (let n: number = 0; n < 2; n++) {
          const polygon: any = document.createElementNS(
            svgElement.namespaceURI,
            'polygon'
          )
          if (rando === 0) {
            if (n === 0) {
              polygon.point1 = i
              polygon.point2 = i + this.numPointsX
              polygon.point3 = i + this.numPointsX + 1
              polygon.setAttribute(
                'points',
                topLeftX +
                  ',' +
                  topLeftY +
                  ' ' +
                  bottomLeftX +
                  ',' +
                  bottomLeftY +
                  ' ' +
                  bottomRightX +
                  ',' +
                  bottomRightY
              )
            } else if (n === 1) {
              polygon.point1 = i
              polygon.point2 = i + 1
              polygon.point3 = i + this.numPointsX + 1
              polygon.setAttribute(
                'points',
                topLeftX +
                  ',' +
                  topLeftY +
                  ' ' +
                  topRightX +
                  ',' +
                  topRightY +
                  ' ' +
                  bottomRightX +
                  ',' +
                  bottomRightY
              )
            }
          } else if (rando === 1) {
            if (n === 0) {
              polygon.point1 = i
              polygon.point2 = i + this.numPointsX
              polygon.point3 = i + 1
              polygon.setAttribute(
                'points',
                topLeftX +
                  ',' +
                  topLeftY +
                  ' ' +
                  bottomLeftX +
                  ',' +
                  bottomLeftY +
                  ' ' +
                  topRightX +
                  ',' +
                  topRightY
              )
            } else if (n === 1) {
              polygon.point1 = i + this.numPointsX
              polygon.point2 = i + 1
              polygon.point3 = i + this.numPointsX + 1
              polygon.setAttribute(
                'points',
                bottomLeftX +
                  ',' +
                  bottomLeftY +
                  ' ' +
                  topRightX +
                  ',' +
                  topRightY +
                  ' ' +
                  bottomRightX +
                  ',' +
                  bottomRightY
              )
            }
          }
          polygon.setAttribute('fill', 'rgba(0,0,0,' + Math.random() / 3 + ')')
          if (this.canAnimate) {
            const animate = document.createElementNS(
              'http://www.w3.org/2000/svg',
              'animate'
            )
            animate.setAttribute('fill', 'freeze')
            animate.setAttribute('attributeName', 'points')
            animate.setAttribute('dur', this.refreshDuration + 'ms')
            animate.setAttribute('calcMode', 'linear')
            polygon.appendChild(animate)
            svgElement.appendChild(polygon)
          }
        }
      }
    }
    this.refresh()
  }

  mounted() {
    this.isMounted = true
    this.pageColors = [
      { pageName: 'index', color: 'black' },
      { pageName: 'home', color: 'light-grey' },
      { pageName: 'about', color: 'red' },
      { pageName: 'training', color: 'white' },
      { pageName: 'gallery', color: 'dark-grey' },
      { pageName: 'contact', color: 'red' },
    ]
    const route: Route = this.$route
    if (route && route?.name) {
      // const tmp: string[] = route.name.split('___')
      // const routeName: string = tmp[0]
      this.setColorBeforeLoad(route.name)
      // $(window).on('resize', this.onResize)
    }
  }

  // beforeDestroy() {
  // $(window).off('resize', this.onResize)
  // }
}
